module.exports = __webpack_public_path__ + "static/media/chevron_down.5a217d8d.svg";